import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { FeaturedLayout } from '../layouts'
import { Button } from '../ui'
import { getPlayerById } from '../../lib/supabase'
import PlayerForm from './PlayerForm'

// La ruta decide de donde sale el jugador y a donde se va uno al terminar. El
// formulario no sabe nada de eso: sigue recibiendo al jugador por prop, que es lo que
// deja vivos sus tests sin montarles un router encima.
const PlayerFormPage = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [player, setPlayer] = useState(null)
  const [loading, setLoading] = useState(!!id)

  // La query de la lista viaja en el state de la navegacion para que regresar devuelva
  // los filtros puestos. Un formulario abierto por un enlace pegado no trae state: cae
  // a la lista limpia, que es lo correcto.
  const listaQuery = location.state?.listaQuery || ''

  const load = useCallback(async () => {
    if (!id) { setLoading(false); return }
    setLoading(true)
    const { data } = await getPlayerById(id)
    setPlayer(data)
    setLoading(false)
  }, [id])

  useEffect(() => { load() }, [load])

  // Al terminar se va al perfil del jugador -- el recien creado o el editado -- porque
  // ahi sigue el trabajo: asignarle grupo.
  const alGuardar = (guardado) => {
    const destino = guardado?.id || id
    if (destino) navigate(`/admin/jugadores/${destino}`, { state: { listaQuery } })
    else navigate('/admin/jugadores' + listaQuery)
  }

  const alCancelar = () => {
    if (id) navigate(`/admin/jugadores/${id}`, { state: { listaQuery } })
    else navigate('/admin/jugadores' + listaQuery)
  }

  return (
    <FeaturedLayout title={id ? 'Editar jugador' : 'Nuevo jugador'} subtitle={player?.nombre_completo}>
      <div className="mb-4">
        <Button variant="ghost" size="sm" onClick={alCancelar}>
          <ArrowLeft className="h-4 w-4 mr-1" /> {id ? 'Perfil' : 'Jugadores'}
        </Button>
      </div>
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      ) : (
        <PlayerForm player={player} onSaved={alGuardar} onCancel={alCancelar} />
      )}
    </FeaturedLayout>
  )
}

export default PlayerFormPage
